module.exports = __webpack_public_path__ + "img/floorMap.b609e12b.png";